import { castStringIdRouteParams } from '../helpers/helpers'

export default [
    {
        path: '/administration/users',
        name: 'administration/users',
        component: () => import('../views/administration/Users.vue'),
        meta: { title: 'sideMenu.users', claims: [{ name: 'aspNetUser', crud: 'read' }] }
    },
    {
        path: '/administration/user/manage/:id',
        name: 'administration/user/manage',
        component: () => import('../views/administration/UserManagement.vue'),
        props: (route) => ({ id: route.params.id }),
        meta: { title: 'userManagement.title', claims: [{ name: 'aspNetUser', crud: 'read' }] }
    },
    {
        path: '/administration/usergroups',
        name: 'administration/usergroups',
        component: () => import('../views/administration/role/List1.vue'),
        meta: { title: 'sideMenu.usergroups', claims: [{ name: 'aspNetRole', crud: 'read' }] }
    },
    {
        path: '/administration/roles/edit/:id',
        name: 'editRolesClaims',
        component: () => import('../views/administration/role/Role.vue'),
        props: castStringIdRouteParams,
        meta: { title: '', claims: [{ name: 'aspNetRole', crud: 'read' }] } // title-а е малко сложен и се прави в компонентата
    },
    {
        path: '/administration/usersByRole/:id',
        name: 'manageUserRole',
        component: () => import('../views/administration/role/PersonGridByRole'),
        props: castStringIdRouteParams,
        meta: { title: '', claims: [{ name: 'aspNetRole', crud: 'read' }] }
    },
    {
        path: '/administration/nomenclature',
        name: 'administration/nomenclature',
        component: () => import('../views/administration/nomenclature/NomenclatureGrid.vue'),
        meta: { claims: [{ name: 'nomenclature', crud: 'read' }] }
    },
    {
        path: '/administration/foreignCities',
        name: 'administration/foreignCities',
        component: () => import('../views/administration/nomenclature/ForeignCitiesGrid.vue'),
        meta: { claims: [{ name: 'nomenclature', crud: 'read' }] }
    },
    {
        path: '/administration/nipData',
        name: 'administration/nipData',
        component: () => import('../views/administration/NIPData.vue'),
        meta: { claims: [{ name: 'nijData', crud: 'read' }] }
    },
    {
        path: '/administration/externalServices',
        name: '/administration/externalServices',
        component: () => import('../views/administration/ExternalServices.vue'),
        meta: { claims: [{ name: 'externalServices', crud: 'read' }] }
    },
    {
        path: '/administration/notifications',
        name: 'administration/notifications',
        component: () => import('../views/administration/notifications/List.vue'),
        meta: { claims: [{ name: 'notifications', crud: 'read' }] }
    },
    {
        path: '/administration/notifications/edit/:id',
        name: 'editNotificationConfig',
        component: () => import('../views/administration/notifications/NotificationConfig.vue'),
        meta: { claims: [{ name: 'notifications', crud: 'update' }, { name: 'notifications', crud: 'create' }] },
        props: castStringIdRouteParams
    },
    {
        path: '/administration/notifications/details/:id',
        name: 'viewNotificationConfig',
        component: () => import('../views/administration/notifications/NotificationConfigDetails.vue'),
        meta: { claims: [{ name: 'notifications', crud: 'read' }] },
        props: castStringIdRouteParams
    },
    {
        path: '/dynamic/fieldTypes',
        name: 'dynamicFieldTypes',
        component: () => import('../views/administration/dynamicRegisters/FieldTypes.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    // {
    //    path: '/dynamic/registerTypes',
    //    name: 'dynamicRegisterTypes',
    //    component: () => import('../views/administration/dynamicRegisters/RegisterTypes.vue'),
    //    meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    // },
    {
        path: '/dynamic/staticRegistersForDropdown',
        name: 'staticRegistersForDropdown',
        component: () => import('../views/administration/dynamicRegisters/StaticRegistersForDropdown.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/dynamic/fieldCodes',
        name: 'fieldCodes',
        component: () => import('../views/administration/dynamicRegisters/FieldCodes.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/dynamic/list',
        name: 'dynamicRegistersList',
        component: () => import('../views/administration/dynamicRegisters/List.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/dynamic/fieldDetails',
        name: 'dynamicRegisterFieldDetails',
        component: () => import('../views/administration/dynamicRegisters/FieldsDetails.vue'),
        props: () => ({ fieldDetailsType: 'registers' }),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'read' }] }
    },
    {
        path: '/administration/participantsClaims',
        name: 'participantsClaims',
        component: () => import('../views/administration/participantsClaims/List.vue'),
        meta: { claims: [{ name: 'claimsAdministration', crud: 'read' }] }
    },
    {
        path: '/administration/participantsClaims/edit/:id',
        name: 'editParticipantsClaims',
        component: () => import('../views/administration/participantsClaims/Edit.vue'),
        meta: { claims: [{ name: 'claimsAdministration', crud: 'read' }] },
        props: castStringIdRouteParams
    },
    {
        path: '/administration/applicationSettings',
        name: 'applicationSettings',
        component: () => import('../views/administration/ApplicationSettings.vue'),
        meta: { claims: [{ name: 'applicationSettings', crud: 'read' }] }
    },
    {
        path: '/administration/tasks',
        name: 'administration/tasks',
        component: () => import('../views/administration/Tasks.vue'),
        meta: {
            claims: [{ name: 'tasksAdministration', crud: 'read' }],
            title: 'sideMenu.tasks',
            titleDescription: ''
        }
    },
    {
        path: '/administration/coordinations',
        name: 'administration/coordinations',
        component: () => import('../views/administration/Coordinations.vue'),
        meta: {
            claims: [{ name: 'coordinationsAdministration', crud: 'read' }],
            title: 'sideMenu.coordinations',
            titleDescription: ''
        }
    },
    {
        path: '/administration/signatures',
        name: 'administration/signatures',
        component: () => import('../views/administration/Signatures.vue'),
        meta: {
            // claims: [{ name: 'tasks', crud: 'read' }], // Todo: policy за четене на собствени процедури по подписване
            title: 'sideMenu.signatures',
            titleDescription: ''
        }
    },
    {
        path: '/administration/participationType',
        name: '/administration/participationType',
        component: () => import('../views/administration/ParticipationType.vue'),
        meta: { claims: [{ name: 'nomenclatureTypes', crud: 'read' }] }
    },
     {
        path: '/administration/participationRelationType',
        name: '/administration/participationRelationType',
        component: () => import('../views/administration/ParticipationRelationType.vue'),
        meta: { claims: [{ name: 'nomenclatureTypes', crud: 'read' }] }
    },
    {
        path: '/administration/benchmarkType',
        name: '/administration/benchmarkType',
        component: () => import('../views/administration/BenchmarkType.vue'),
        meta: { claims: [{ name: 'nomenclatureTypes', crud: 'read' }] }
    },
    {
        path: '/administration/reasonForAdmission',
        name: '/administration/reasonForAdmission',
        component: () => import('../views/administration/ReasonForAdmission.vue'),
        meta: { claims: [{ name: 'nomenclatureTypes', crud: 'read' }] }
    },
    {
        path: '/administration/eventStatus',
        name: '/administration/eventStatus',
        component: () => import('../views/administration/EventStatus.vue'),
        meta: { claims: [{ name: 'nomenclatureTypes', crud: 'read' }] }
    },
    {
        path: '/administration/eventSubscriptions',
        name: '/administration/eventSubscriptions',
        component: () => import('../views/administration/EventSubscriptions.vue'),
        meta: { claims: [{ name: 'eventSubscriptions', crud: 'read' }] }
    },
    {
        path: '/administration/releaseInfo',
        name: '/administration/releaseInfo',
        component: () => import('../views/administration/ReleaseInfo.vue'),
        meta: { claims: [{ name: 'releaseInfo', crud: 'read' }] }
    },
    {
        path: '/administration/migrationCheck',
        name: '/administration/migrationCheck',
        component: () => import('../views/administration/ParticipantsToMigrationDiffs.vue'),
        meta: { claims: [{ name: 'reportsData', crud: 'read' }] }
    },
    {
        path: '/releaseInfo',
        name: 'releaseInfo',
        component: () => import('../views/info/ReleaseInfo.vue'),
        meta: { claims: [{ name: 'releaseInfo', crud: 'read' }] }
    },
    {
        path: '/administration/localization',
        name: 'administration/localization',
        component: () => import('../views/administration/Localization.vue'),
        meta: { claims: [{ name: 'localization', crud: 'read' }] }
    },
    {
        path: '/administration/emails',
        name: 'administration/emails',
        component: () => import('../views/administration/SentEmails.vue'),
        meta: {
            claims: [{ name: 'email', crud: 'read' }],
            title: 'sideMenu.sentEmails',
            titleDescription: ''
        }
    },
    {
        path: '/administration/archivedEvents',
        name: '/administration/archivedEvents',
        component: () => import('../views/registers/dynamic/events/ListEvents.vue'),
        props: { registerName: 'events', archived: true, title: 'sideMenu.archivedEvents' },
        meta: { claims: [{ name: 'event', crud: 'delete' }] }
    },
    {
        path: '/company/list',
        name: '/company/list',
        component: () => import('../views/company/List.vue'),
        meta: { claims: [{ name: 'company', crud: 'read' }] }
    },
    {
        path: '/company/:id/edit',
        name: '/company/edit',
        component: () => import('../views/company/Company.vue'),
        props: (route) => ({ id: Number(route.params.id), skipValidation: route.query.skipValidation === 'true' }),
        meta: { claims: [{ name: 'company', crud: 'update' }] }
    },
    {
        path: '/administration/deletedRecords/lecturers',
        name: '/administration/deletedRecords/lecturers',
        component: () => import('../views/deletedRecords/DeletedLecturers.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/institutions',
        name: '/administration/deletedRecords/institutions',
        component: () => import('../views/deletedRecords/DeletedInstitutions.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/places',
        name: '/administration/deletedRecords/places',
        component: () => import('../views/deletedRecords/DeletedPlaces.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/accommodationPlaces',
        name: '/administration/deletedRecords/accommodationPlaces',
        component: () => import('../views/deletedRecords/DeletedAccommodationPlaces.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/projects',
        name: '/administration/deletedRecords/projects',
        component: () => import('../views/deletedRecords/DeletedProjects.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/publicOrders',
        name: '/administration/deletedRecords/publicOrders',
        component: () => import('../views/deletedRecords/DeletedPublicOrders.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/activities',
        name: '/administration/deletedRecords/activities',
        component: () => import('../views/deletedRecords/DeletedАctivities.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/thematicAreas',
        name: '/administration/deletedRecords/thematicAreas',
        component: () => import('../views/deletedRecords/DeletedТhematicAreas.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/administrativePositions',
        name: '/administration/deletedRecords/administrativePositions',
        component: () => import('../views/deletedRecords/DeletedАdministrativePositions.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/deletedEvents',
        name: '/administration/deletedRecords/deletedEvents',
        component: () => import('../views/deletedRecords/DeletedEvents.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
    {
        path: '/administration/deletedRecords/documents',
        name: '/administration/deletedRecords/documents',
        component: () => import('../views/deletedRecords/DeletedDocuments.vue'),
        meta: { claims: [{ name: 'deletedRecords', crud: 'read' }] }
    },
]
